export function calcNoPrice(price: number | null | undefined): number | null {
  if (price === null || price === undefined) return null;
  return 1 - price;
}

type FormatCentsOptions = {
  forceFixed1?: boolean;
  fixedDecimals?: number;
};

export function formatCents(
  price: number | null | undefined,
  options?: FormatCentsOptions
): string {
  if (price == null) return "—";
  if (!Number.isFinite(price)) return "—";

  const cents = price * 100;

  if (options?.fixedDecimals !== undefined) {
    const factor = 10 ** options.fixedDecimals;
    const rounded = Math.round((cents + Number.EPSILON) * factor) / factor;

    return `${rounded.toFixed(options.fixedDecimals)}¢`;
  }

  const rounded1 = Math.round((cents + Number.EPSILON) * 10) / 10;

  const text = options?.forceFixed1
    ? rounded1.toFixed(1)
    : Number.isInteger(rounded1)
      ? String(rounded1)
      : rounded1.toFixed(1);

  return `${text}¢`;
}
